/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface ListSupplies$Params {
  VenueId?: string;
  Filter?: string;
  PageNumber?: number;
  PageSize?: number;
}

export function listSupplies(http: HttpClient, rootUrl: string, params?: ListSupplies$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, listSupplies.PATH, 'get');
  if (params) {
    rb.query('VenueId', params.VenueId, {});
    rb.query('Filter', params.Filter, {});
    rb.query('PageNumber', params.PageNumber, {});
    rb.query('PageSize', params.PageSize, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

listSupplies.PATH = '/api/mng/Supply/listsupplies';
